// Minimal browser shim for Node's 'crypto' module used by some CJS builds.
// Provides randomBytes using Web Crypto API.

export function randomBytes(size: number): Uint8Array {
  const array = new Uint8Array(size);
  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(array);
    return array;
  }
  // Fallback (very unlikely in modern browsers)
  for (let i = 0; i < size; i++) {
    array[i] = Math.floor(Math.random() * 256);
  }
  return array;
}

export default { randomBytes };
